import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

/**
 * Componente para proteger elementos basados en permisos
 * @param {string} modulo - Nombre del módulo
 * @param {string} accion - Acción requerida (Read, Create, Update, Delete, etc.)
 * @param {React.ReactNode} children - Contenido a mostrar si tiene permiso
 * @param {React.ReactNode} fallback - Contenido a mostrar si no tiene permiso (opcional)
 * @param {boolean} showIfNoPermission - Si es true, muestra el contenido si NO tiene permiso (opcional)
 */
const PermissionGuard = ({ 
  modulo, 
  accion, 
  children, 
  fallback = null,
  showIfNoPermission = false 
}) => {
  const { hasPermission } = usePermissions();
  
  const hasAccess = hasPermission(modulo, accion);
  
  // Si showIfNoPermission es true, invertir la lógica
  const shouldShow = showIfNoPermission ? !hasAccess : hasAccess;
  
  if (shouldShow) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};

export default PermissionGuard;

